/**
 * moduł trzymający informacje o validacji
 *@module validate
 */
app.service('validate', function (front, passwordInvalid) {
	var rules = {
		email: {
			required: true,
			email: true,
			maxlength: 200
		},
		strongPassword: {
			passwordStrong: true
		},
		passwordNewRepeat: {
			required: true,
			equalTo: "#password"
		},
		email2: {
			email: true
		},
		emailRepeat: {
			required: true,
			email: true,
			equalTo: "#email"
		},
		recaptcha: {
			required: true
		},
		passwordOld: {
			required: true
		},
		login: {
			required: true
		},
		password: {
			required: true,
			minlength: 5
		},
		passwordRepeat: {
			required: true,
			equalTo: "#password"
		},
		firstname: {
			required: true,
			minlength: 2,
			firstname: true
		},
		surname: {
			required: true,
			minlength: 2,
			surname: true
		},
		userType: {
			required: true
		},
		countryCode: {
			required: true,
			minlength: 2
		},
		zipCode: {
			required: true,
			zipCode: true
		},
		phone: {
			required: true,
			phone: true
		},
		city: {
			required: true,
			minlength: 2,
			maxlength: 40,
			city: true
		},
		street: {
			required: true,
			minlength: 2,
			maxlength: 60,
			street: true
		},
		nip: {
			required: true,
			nip: true
		},
		numberId: {
			maxlength: 50,
			required: true,
			numberId: true
		},
		vatUe: {
			required: true,
			vatUe: true
		},
		companyName: {
			required: true,
			maxlength: 160,
			companyName: true
		},
		employeeName: {
			required: true,
			minlength: 2,
			maxlength: 80,
			employeeName: true
		},
		houseNumber: {
			required: true,
			maxlength: 10,
			houseNumber: true
		},
		flat: {
			maxlength: 10,
			flat: true
		},
		role: {
			required: true
		},
		internalId: {
			required: true,
			internalId: true
		},
		termsAccepted: {
			required: true
		},
		pesel: {
			required: true,
			pesel: true
		},
		warrantyRegulations: {
			required: true
		},
		shopCode: {
			required: true,
			minlength: 2
		},
		cityCode: {
			required: true,
			min: 1
		},
		percentageShare: {
			required: true,
			percentageShare: true
		},
		roleDescription: {
			required: true,
			maxlength: 256
		},
		parcelMachineCode: {
			required: true
		},
		postOfficeCode: {
			required: true
		},
		pofficeZipCode: {
			zipCode: true
		},
		postCityCode: {
			required: false
		},
		messageTextarea: {
			required: true
		},
		parcelMachineCity: {
			required: true
		},
		birthday: {
			required: true,
			birthday: true
		},
		notice: {
			required: true,
			email: true
		},
		nick: {
			required: true,
			maxlength: 200
		},
		opinion: {
			required: true,
			minlength: 20,
			maxlength: 5000
		},
		opinionStars: {
			required: true
		},
		instalmentShopCode: {
			required: true,
			minlength: 2
		},
		instalmentCityCode: {
			required: true,
			min: 1
		},
		ePaymentBank: {
			required: true,
			minlength: 1
		},
		ePaymentBankBluemedia: {
			required: true,
			minlength: 1
		},
		instalmentCheckbox: {
			required: true
		},
		giftCardValue: {
			required: true,
			min: 10,
			max: 10000
		},
		giftCardStyle:{
			required: true
		},
		agreement: {
			required: true
		},
		optionalPhone: {
			required: false,
			phone: true
		},
		captcha: {
			required: true
		},
		bankName: {
			required: true
		},
		bankAccountNumber: {
			required: true,
			bankAccountNumber: true
		},
	};
	var messages = {
		firstname: {
			required: "Podaj imię",
			minlength: "Imię jest za krótkie"
		},
		surname: {
			required: "Podaj nazwisko",
			minlength: "Nazwisko jest za krótkie"
		},
		userType: {
			required: "Wybierz sposób zakupów"
		},
		countryCode: {
			required: "Wybierz kraj",
			minlength: "Wybierz kraj"
		},
		zipCode: {
			required: "Podaj kod pocztowy"
		},
		city: {
			required: "Podaj miejscowość",
			minlength: "Miasto jest za krótkie",
			maxlength: "Pole może zawierać maksymalnie 40 znaków"
		},
		phone: {
			required: "Podaj numer telefonu",
			phone: "Podaj poprawny numer telefonu (9 cyfr)"
		},
		street: {
			required: "Podaj ulicę",
			minlength: "Ulica jest za krótka",
			maxlength: "Pole może zawierać maksymalnie 60 znaków"
		},
		companyName: {
			required: "Podaj nazwę firmy",
			maxlength: "Pole może zawierać maksymalnie 160 znaków"
		},
		employeeName: {
			required: "Podaj imię i nazwisko pracownika",
			minlength: "Imię i nazwisko jest za krótkie"
		},
		nip: {
			required: "Podaj NIP"
		},
		role: {
			required: "Wybierz rolę"
		},
		internalId: {
			required: "Podaj ID Wewnętrzne"
		},
		vatUe: {
			required: "Podaj numer VAT UE",
		},
		numberId: {
			required: "Podaj Numer ID",
			maxlength: "Pole może zawierać maksymalnie 50 znaków"
		},
		percentageShare: {
			required: "Podaj Udział"
		},
		roleDescription: {
			required: "Podaj Opis roli"
		},
		houseNumber: {
			required: "Podaj numer domu",
			maxlength: "Pole może zawierać maksymalnie 10 znaków"
		},
		flat: {
			maxlength: "Pole może zawierać maksymalnie 10 znaków"
		},
		login: {
			required: "Podaj login"
		},
		passwordOld: {
			required: "Podaj swoje hasło"
		},
		passwordNew: {
			required: "Podaj nowe hasło",
			minlength: "Podaj co najmniej 5 znaków"
		},
		passwordRepeat: {
			required: "Powtórz nowe hasło",
			equalTo: "Hasła muszą być identyczne"
		},
		passwordNewRepeat: {
			required: "Powtórz hasło",
			equalTo: "Hasła muszą być identyczne"
		},
		email: {
			required: "Wpisz adres e-mail",
			email: "Wpisz poprawny adres e-mail",
			maxlength: "Podany adres e-mail jest za długi"
		},
		email2: {
			email: "Podaj poprawnego e-maila albo pozostaw pole puste"
		},
		emailRepeat: {
			required: "Powtórz adres e-mail",
			email: "Powtórz poprawny adres e-mail",
			equalTo: "Podane adresy nie są identyczne"
		},
		recaptcha: {
			required: "Prosimy zaznacz nie jestem robotem"
		},
		termsAccepted: {
			required: "Akceptacja Regulaminu jest wymagana"
		},
		noReturnNoticeAccepted: {
			required: "Akceptacja jest wymagana"
		},
		pesel: {
			required: "Podaj numer PESEL"
		},
		warrantyRegulations: {
			required: "Zapoznaj sie z warunkami ubezpieczenia"
		},
		shopCode: {
			required: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary",
			minlength: front.euro ? "Wybierz sklep, w którym chcesz odebrać Towary" : "Wybierz punkt odbioru, w którym chcesz odebrać Towary"
		},
		cityCode: {
			required: "Wybierz miejscowość, w której chcesz odebrać Towary",
			min: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		parcelMachineCode: {
			required: "Wybierz Paczkomat®, w którym chcesz odebrać Towary"
		},
		postOfficeCode: {
			required: "Proszę wybrać punkt odbioru, w którym chcesz odebrać produkt"
		},
		// postCityCode:{
		// 	required: 'Wybierz placówkę pocztową, w której chcesz odebrać produkty'
		// },
		messageTextarea: {
			required: "Wiadomość nie może być pusta"
		},
		parcelMachineCity: {
			required: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		ePaymentBank: {
			required: "Wybierz bank"
		},
		notice: {
			required: "Wpisz adres e-mail",
			email: "Wpisz poprawny adres e-mail"
		},
		birthday: {
			required: "Podaj datę urodzin"
		},
		nick: {
			required: "Podaj nick",
			maxlength: "Podany nick jest za długi"
		},
		opinion: {
			required: "Podaj treść Opinii",
			minlength: "Podana treść jest za krótka",
			maxlength: "Podana treść jest za długa"
		},
		instalmentShopCode: {
			required: "Wybierz sklep, w którym chcesz odebrać Towary",
			minlength: "Wybierz sklep, w którym chcesz odebrać Towary"
		},
		instalmentCityCode: {
			required: "Wybierz miejscowość, w której chcesz odebrać Towary",
			min: "Wybierz miejscowość, w której chcesz odebrać Towary"
		},
		ePaymentBankBluemedia: {
			required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
		},
		instalmentCheckbox: {
			required: "Ten warunek jest konieczny aby przejść do kolejnego etapu zamówienia"
		},
		giftCardValue: {
			required: "Wybierz wartość Karty Podarunkowej",
			min: "Minimalna wartość karty to 10zł",
			max: "Maksymalna wartość karty to 10000zł"
		},
		giftCardStyle:{
			required: "Wybierz wzór Karty Podarunkowej"
		},
		agreement: {
			required: "Zgoda jest wymagana"
		},
		optionalPhone: {
			phone: "Podaj poprawny numer telefonu (9 cyfr)"
		},
		captcha: {
			required: "Przepisz tekst z obrazka"
		},
		bankName: {
			required: "Wybierz bank"
		},
		bankAccountNumber: {
			required: "Podaj numer konta bankowego",
		},
	};
	var accountErrorPlacement = function (error, element) {
		var $validateTarget = element.closest('.validate-target');
		$validateTarget.addClass('validate-error').removeClass('validate-ok');
		if (element.is('.select3-input')) {
			$validateTarget.find('.select3-container').after(error);
		} else {
			error.insertAfter(element);
		}
	}
	var defaults = {
		ignore: ".ignore",
		errorElement: "label",
		success: function(label) {
			var $validateTarget = label.closest('.validate-target');
			if ($validateTarget.length) {
				$validateTarget.addClass('validate-ok').removeClass('validate-error');
			}
			if (label.parent().hasClass('validate-error')) {
				label.parent().addClass('validate-ok').removeClass('validate-error');
			}
			label.remove();
		},
		invalidHandler: function(form, validator) {
			if (!$(form.target).closest('.remodal-wrapper').length) { //jeśli bład występuje na warstwie to nie przesuwamy
				var $elementWithError = $(validator.errorList[0].element);
				var $elementToScroll = false;
				if ($elementWithError.closest('.validate-target').length) {
					$elementToScroll = $elementWithError.closest('.validate-target');
				} else {
					$elementToScroll = $elementWithError.parent();
				}
				if($elementToScroll && $elementToScroll.length){
					let topHeight = $elementToScroll.offset().top + $elementToScroll.height();
					let bottomHeight = $elementToScroll.offset().top;
					//console.log(topHeight , "<", window.scrollY, ' || ', bottomHeight, ' > ', window.scrollY + window.innerHeight)
					if(topHeight < window.scrollY || bottomHeight > window.scrollY + window.innerHeight){
						$.scrollTo($elementToScroll);
					}
				}
			}
		},
		errorPlacement: function (error, element) {
			var $validateTarget = element.closest('.validate-target');
			if (element.attr('type') == 'radio' && element.closest('.radio-group').length) {
				error.appendTo(element.closest('.radio-group'));
			} else if (element.attr('type') == 'checkbox') {
				element.parent().addClass('validate-error').append(error);
				/* Najbliższemu elementowi o klasie validate-target także nadaj error */
				$validateTarget.addClass('validate-error').removeClass('validate-ok');
			} else if ($validateTarget.length) {
				$validateTarget.addClass('validate-error').removeClass('validate-ok');
				$validateTarget.append(error);
			} else {
				error.insertAfter(element);
			}
		}
	};

	function setOptions(options) {
		var obj = {};
		for (var i in defaults) {
			obj[i] = defaults[i];
		}
		return $.extend(true, obj, options);
	}
	var tasks = {
		warrantyUpsellingForm({ $form, submitHandler }) {
			const options = setOptions({
				submitHandler: submitHandler,
				rules: {
					"acceptance-1": {
						required: true
					},
					"acceptance-2": {
						required: true
					}
				},
				messages: {
					"acceptance-1": {
						required: "Zapoznaj sie z warunkami ubezpieczenia"
					},
					"acceptance-2": {
						required: "Zapoznaj się z Regulaminem płatności cyklicznej"
					}
				}
			});
			$form.validate(options);
		},
		warrantyUpsellingPaymentForm({ $form, submitHandler }) {
			const options = setOptions({
				submitHandler: submitHandler,
				rules: {
					"agreement": rules.warrantyRegulations
				},
				messages: {
					"agreement": messages.warrantyRegulations
				}
			});
			$form.validate(options);
		},
		subscriptionServiceInvoiceDataForm: function(props) {
			const { $form, onValidInvoiceData } = props;
			const options = setOptions({
				submitHandler: onValidInvoiceData,
				rules: {
					"invoiceData.firstName": rules.firstname,
					"invoiceData.lastName": rules.surname,
					"invoiceData.address.zipCode": rules.zipCode,
					"invoiceData.address.city": rules.city,
					"invoiceData.address.street": rules.street,
					"invoiceData.address.flatNumber": rules.flat,
					"invoiceData.address.houseNumber": rules.houseNumber,
					"invoiceData.nip": rules.nip,
					"invoiceData.numberId": rules.numberId,
					"invoiceData.numberIdCountryCode": {
						maxlength: 2,
						numberIdCountryCode: true
					},
					"invoiceData.companyName": rules.companyName,
					"additionalInvoiceEntity.companyName": rules.companyName,
					"additionalInvoiceEntity.employeeName": rules.employeeName,
					"additionalInvoiceEntity.nip": rules.nip,
					"additionalInvoiceEntity.numberId": rules.numberId,
					"additionalInvoiceEntity.numberIdCountryCode": {
						maxlength: 2,
						numberIdCountryCode: true
					},
					"additionalInvoiceEntity.internalId": rules.internalId,
					"additionalInvoiceEntity.address.street": rules.street,
					"additionalInvoiceEntity.address.houseNumber": rules.houseNumber,
					"additionalInvoiceEntity.address.flatNumber": rules.flat,
					"additionalInvoiceEntity.address.zipCode":  rules.zipCode,
					"additionalInvoiceEntity.address.city": rules.city,
					"additionalInvoiceEntity.percentageShare": rules.percentageShare,
					"additionalInvoiceEntity.roleDescription": rules.roleDescription,
					"additionalInvoiceEntity.email": rules.email,
				},
				messages: {
					"invoiceData.firstName": messages.firstname,
					"invoiceData.lastName": messages.surname,
					"invoiceData.address.zipCode": messages.zipCode,
					"invoiceData.address.city": messages.city,
					"invoiceData.address.street": messages.street,
					"invoiceData.address.flatNumber": messages.flat,
					"invoiceData.address.houseNumber": messages.houseNumber,
					"invoiceData.nip": messages.nip,
					"invoiceData.numberId": messages.numberId,
					"invoiceData.companyName": messages.companyName,
					"additionalInvoiceEntity.companyName": messages.companyName,
					"additionalInvoiceEntity.employeeName": messages.employeeName,
					"additionalInvoiceEntity.nip": messages.nip,
					"additionalInvoiceEntity.numberId": messages.numberId,
					"additionalInvoiceEntity.internalId": messages.internalId,
					"additionalInvoiceEntity.address.street": messages.street,
					"additionalInvoiceEntity.address.houseNumber": messages.houseNumber,
					"additionalInvoiceEntity.address.flatNumber": messages.flat,
					"additionalInvoiceEntity.address.zipCode":  messages.zipCode,
					"additionalInvoiceEntity.address.city": messages.city,
					"additionalInvoiceEntity.percentageShare": messages.percentageShare,
					"additionalInvoiceEntity.roleDescription": messages.roleDescription,
					"additionalInvoiceEntity.email": messages.email,
				},
				errorPlacement: accountErrorPlacement
			});
			$form.validate(options);
		},
		errorForm: function(sendFunction) {
			var form = $('#error-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"description": {
						required: true
					},
					"email": {
						email: true,
						required: () => $("#error-subject").val() != 'CONTENT_VIOLATION_ERROR'
					},
					"legalStatementSelected": {
						required: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"description": {
						required: "Wpisz treść wiadomości"
					},
					"email": {
						email: "Podaj poprawny adres e-mail",
						required: "Wpisz adres e-mail"
					},
					"legalStatementSelected": {
						required: "Akceptacja oświadczenia jest wymagana"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleVoteUpForm: function(sendFunction) {
			var form = $('#article-vote-up-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"content": {
						required: true
					},
					"email": {
						required: function(){
							return $('#vote-up-email-agreement', form).is(':checked');
						},
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"content": {
						required: "Wpisz treść wiadomości"
					},
					"email": {
						required: "Wpisz adres e-mail",
						email: "Wpisz poprawny adres e-mail"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleVoteDownForm: function(sendFunction) {
			var form = $('#article-vote-down-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"reason": {
						required: true
					},
					"email": {
						required: function(){
							return $('#vote-down-email-agreement', form).is(':checked');
						},
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"reason": {
						required: "Wybierz jedną z opcji",
					},
					"email": {
						required: "Wpisz adres e-mail",
						email: "Wpisz poprawny adres e-mail"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		articleAdviceForm: function(sendFunction) {
			var form = $('#article-advice-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"topic": {
						required: true
					},
					"content": {
						required: true
					},
					"email": {
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"topic": {
						required: "Wpisz temat"
					},
					"content": {
						required: "Wpisz treść wiadomości"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		technicalError: function(sendFunction) {
			var form = $('#technical-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"description": {
						required: true
					}
				},
				messages: {
					"description": {
						required: "Wpisz treść wiadomości"
					}
				}
			});
			form.validate(options);
		},
		keycloakRemoveAccount: function(){
			var options = setOptions({
				rules:{
					"confirm1": {
						required:true
					},
					"confirm2": {
						required:true
					},
					"confirm3": {
						required:true
					},
					"confirm4": {
						required:true
					}
				},
				messages:{
					"confirm1":  {
						required:"Usunięcie konta wymaga potwierdzenia"
					},
					"confirm2":  {
						required:"Usunięcie konta wymaga potwierdzenia"
					},
					"confirm3":  {
						required:"Usunięcie konta wymaga potwierdzenia"
					},
					"confirm4":  {
						required:"Usunięcie konta wymaga potwierdzenia"
					}
				}
			});
			$('#keycloak-remove-account-form-1').validate(options);
			$('#keycloak-remove-account-form-2').validate(options);
		},
		opinion: function(settings) {
			var form = $("#add-opinion-form form");
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					"opinion": rules.opinion,
					"nick": rules.nick,
					"email": rules.email,
					"opinionStars": {
						min: settings.starLength
					},
					"opinionTermsAccepted": rules.agreement
				},
				messages: {
					"opinion": messages.opinion,
					"nick": messages.nick,
					"email": messages.email,
					"opinionStars": {
						min: "Zaznacz ocenę Towaru"
					},
					"opinionTermsAccepted": messages.agreement
				}
			});
			form.validate(options);
		},
		opinionQuestion: function(sendFunction) {
			var form = $('#question-form' + sendFunction.id);
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction.submit(form);
				},
				rules: {
					"content": rules.opinion,
					"nick": rules.nick,
					"email": rules.email,
				},
				messages: {
					"content": messages.opinion,
					"nick": messages.nick,
					"email": messages.email,
				}
			});
			form.validate(options);
		},
		opinionAnswer: function(sendFunction) {
			var form = $('#answer-mode-form' + sendFunction.id + ' form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction.submit(form);
				},
				rules: {
					"content": rules.opinion,
					"nick": rules.nick,
					"email": rules.email,
				},
				messages: {
					"content": messages.opinion,
					"nick": messages.nick,
					"email": messages.email,
				}
			});
			form.validate(options);
		},
		warrantyEncouragement: function(sendFunction) {
			var $form = $('#warranty-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction();
				},
				errorLabelContainer: $form.find('.js-warranty-error'),
				rules: {
					"warranty_": {
						required: true
					}
				},
				messages: {
					"warranty_": {
						required: "Wybierz jedną z opcji ochrony"
					}
				}
			});
			$form.validate(options);
		},
		notIssuedOrder: function() {
			var $form = $('#insurance-form');
			var options = setOptions({
				rules: {
					"firstName": rules.firstname,
					"lastName": rules.surname,
					"email": rules.email2,
					"zipCode": {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $('#insurance-country-code').val() !== 'PL' })
					},
					"city": rules.city,
					"companyNamePart1": rules.companyName,
					"nip": rules.nip,
					"vatUe": rules.vatUe,
					"taxIdCountryCode": {
						required: true
					},
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat,
					"recurringPaymentMethod": {
						required: true
					}
				},
				messages: {
					"firstName": messages.firstname,
					"lastName": messages.surname,
					"email": messages.email2,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"companyNamePart1": messages.companyName,
					"nip": messages.nip,
					"vatUe": messages.vatUe,
					"taxIdCountryCode": "Wybierz kod kraju",
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat,
					"recurringPaymentMethod": {
						required: "Wybierz metodę płatności za subskrypcję"
					}
				}
			});
			$form.validate(options);
		},
		wcLogin: function() {
			var $form = $('#wc-login-form');
			var options = setOptions({
				rules: {
					mgLogin: {
						required: true
					},
					mgPassword: {
						required: true
					}
				},
				messages: {
					mgLogin: {
						required: "Podaj login"
					},
					mgPassword: {
						required: "Podaj hasło"
					}
				}
			});
			$form.validate(options);
		},
		notice: function(sendFunction) {
			var form = $("#notice-form");
			var options = setOptions({
				submitHandler: function() {
					sendFunction(form);
				},
				rules: {
					notice: rules.notice,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					notice: messages.notice,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		question: function(sendFunction) {
			var form = $("#question-form");
			var options = setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules: {
					content: {
						required: true,
						minlength: form.data("min-char") / 1,
						maxlength: form.data("max-char") / 1
					},
					questionReceiver: {
						required: true
					}
				},
				messages: {
					content: {
						required: "Podaj treść pytania",
						minlength: form.data("min-text"),
						maxlength: form.data("max-text")
					},
					questionReceiver: {
						required: "Wybierz typ pytania"
					}
				}
			});
			form.validate(options);
		},
		answer: function(params) {
			var form = params.form;
			var options = setOptions({
				submitHandler: function() {
					params.success();
				},
				rules: {
					content: {
						required: true,
						minlength: form.data("min-char") / 1,
						maxlength: form.data("max-char") / 1
					}
				},
				messages: {
					content: {
						required: "Podaj treść odpowiedzi",
						minlength: form.data("min-text"),
						maxlength: form.data("max-text")
					}
				}
			});
			form.validate(options);
		},
		comment: function(params) {
			var form = params.form;
			var options = setOptions({
				submitHandler: function() {
					params.success();
				},
				rules: {
					content: {
						required: true,
						minlength: form.data("min-char") / 1,
						maxlength: form.data("max-char") / 1
					}
				},
				messages: {
					content: {
						required: "Podaj treść komentarza",
						minlength: form.data("min-text"),
						maxlength: form.data("max-text")
					}
				}
			});
			form.validate(options);
		},
		wcClientRegistration: function(params) {
			var options = setOptions({
				submitHandler: function(form) {
					params.submit(form);
				},
				rules: {
					"firstname": rules.firstname,
					"surname": rules.surname,
					"email": rules.email,
					"emailRepeat": rules.emailRepeat,
					"phone": rules.optionalPhone,
					"statuteAccepted": rules.termsAccepted
				},
				messages: {
					"firstname": messages.firstname,
					"surname": messages.surname,
					"email": messages.email,
					"emailRepeat": messages.emailRepeat,
					"phone": messages.optionalPhone,
					"statuteAccepted": messages.termsAccepted
				}
			});
			params.form.validate(options);
		},
		wcClientEditData: function(sendFunction) {
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules: {
					"phone": rules.optionalPhone
				},
				messages: {
					"phone": messages.optionalPhone
				}
			});
			$('#customer-edit-form').validate(options);
		},
		limitedService: function(sendFunction) {
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction(form);
				},
				rules: {
					"zipCode": rules.zipCode,
					"cityName": rules.city
				},
				messages: {
					"zipCode": messages.zipCode,
					"cityName": messages.city
				}
			});
			$('#limited-service-form').validate(options);
		},
		loginView: function(sendFunction) {
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction();
				},
				rules: {
					"j_username": rules.email,
					"j_password": rules.password,
					"captcha" : rules.captcha,
					"g-recaptcha-response" : rules.recaptcha
				},
				messages: {
					"j_username": messages.email,
					"j_password": messages.password,
					"captcha" : messages.captcha,
					"g-recaptcha-response" : messages.recaptcha
				}
			});
			$("#loginView-login").validate(options);
		},
		registerLayer: function(sendFunction) {
			var options = setOptions({
				submitHandler: function() {
					sendFunction();
				},
				rules: {
					nick: rules.nick,
					firstname: rules.firstname,
					surname: rules.surname,
					email: rules.email,
					password: rules.strongPassword,
					password2: rules.passwordRepeat,
					statuteAccepted: rules.termsAccepted,
					"g-recaptcha-response" : rules.recaptcha
				},
				messages: {
					nick: messages.nick,
					firstname: messages.firstname,
					surname: messages.surname,
					email: messages.email,
					password2: messages.passwordRepeat,
					statuteAccepted: messages.termsAccepted,
					"g-recaptcha-response" : messages.recaptcha
				}
			});
			$("#loginView-register").validate(options);
		},
		obligatoryChangePassword: function(sendFunction) {
			var options = setOptions({
				submitHandler: function() {
					sendFunction()
				},
				rules: {
					"password": rules.strongPassword,
					"currentPassword": rules.passwordOld,
					"confirmedPassword": rules.passwordRepeat
				},
				messages: {
					"currentPassword": messages.passwordOld,
					"confirmedPassword": messages.passwordRepeat
				},
			});
			$("#change-password form").validate(options);
		},
		changePayment: function(params){
			var options=setOptions({
				rules:{
					"delayedDeliveryTimeTermsAccepted": {required: true},
					"paymentOperatorAgreementAccepted": {required: true},
					"termsAccepted": {required: true},	// formularz jest dla "zmiany płatności" ale także dla ścieżki negatywnej PAYy i tam jest inne pole na zgody
					"ePaymentBankId": {required: true},
					"deliveryInterval": {required:true}
				},
				messages:{
					"delayedDeliveryTimeTermsAccepted": "Wybór sposobu płatności wymaga akceptacji terminu realizacji",
					"paymentOperatorAgreementAccepted": params.payUMode ? messages.termsAccepted : "Wybór sposobu płatności wymaga akceptacji regulaminu",
					"termsAccepted": params.payUMode ? messages.termsAccepted : "Wybór sposobu płatności wymaga akceptacji regulaminu",
					"ePaymentBankId": "Wybierz bank",
					"deliveryInterval": "Wybierz termin dostawy"
				},
				submitHandler: function(form) {
					params.send();
				},
			});
			params.$form.validate(options);
		},
		complaintForm: function(sendFunction) {
			var form = $('#complaint-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"description": {
						required: true
					},
					"subject": {
						required: true
					}
				},
				messages: {
					"description": {
						required: "Wpisz treść wiadomości"
					},
					"subject": {
						required: "Wybierz kategorię"
					}
				}
			});
			form.validate(options);
		},
		restoreSharedCart: function(sendFunction) {
			var form = $('#restore-cart-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"identifier": {
						required: function() {
							return !form.find("input[name=link]").hasClass('valid');
						}
					},
					"link": {
						required: function() {
							return !form.find("input[name=identifier]").hasClass('valid');
						}
					}
				},
				messages: {
					"identifier": {
						required: "Przynajmniej jedno z pól jest wymagane"
					},
					"link": {
						required: "Przynajmniej jedno z pól jest wymagane"
					}
				}
			});
			form.validate(options);
		},
		notifyForm: function(sendFunction) {
			var form = $('#notify-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"description": {
						required: true
					},
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"description": {
						required: "Wpisz treść wiadomości"
					},
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		availabilityNotificationForm: function(params) {
			const form = params.form;
			const options = setOptions({
				submitHandler: function(form) {
					params.callback(form);
				},
				rules: {
					"email": rules.email,
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"email": messages.email,
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		emptySearchResultsContactForm(callback) {
			let $form = $('#contact-form');
			const options = setOptions({
				submitHandler() {
					callback($form);
				},
				rules: {
					"contact-form-message": {
						required: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"g-recaptcha-response": messages.recaptcha
				}
			});
			$form.validate(options);
		},
		utteranceForm: function(sendFunction) {
			var form = $('#utterance-form');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					"client_description": {
						required: true
					},
					"client_email": {
						email: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					"client_description": {
						required: "Wpisz treść wiadomości"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		rodoForm: function(sendFunction) {
			var form = $('#rodo');
			var options = setOptions({
				submitHandler: function(form) {
					sendFunction($(form));
				},
				rules: {
					firstName: rules.firstname,
					surname: rules.surname,
					newFirstName: rules.firstname,
					newSurname: rules.surname,
					pesel: {
						pesel: true
					},
					email: {
						email: true
					},
					newEmail: {
						email: true
					},
					phone: {
						phone: true
					},
					newPhone: {
						phone: true
					},
					salesmanNumber: {
						required: true
					},
					zipCode: {
						zipCode: true
					},
					newZipCode: {
						zipCode: true
					},
					city: {
						maxlength: 40,
						city: true
					},
					newCity: {
						maxlength: 40,
						city: true
					},
					street: {
						maxlength: 60,
						street: true
					},
					houseNumber: {
						maxlength: 10,
						houseNumber: true
					},
					newStreet: {
						maxlength: 60,
						street: true
					},
					newHouseNumber: {
						maxlength: 10,
						houseNumber: true
					}
				},
				messages: {
					firstName: messages.firstname,
					surname: messages.surname,
					newFirstName: messages.firstname,
					newSurname: messages.surname,
					salesmanNumber: {
						required: 'Numer sprzedawcy jest wymagany'
					}
				}
			});
			form.validate(options);
			if (form.find('label.error').length) {
				$.scrollTo(form.find('label.error:first').offset().top - 200, 0);
			}
		},
		editDefinition: function(settings) {
			var form = $('#dictionary-edit-form');
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					content: {
						required: true
					},
					"g-recaptcha-response": rules.recaptcha
				},
				messages: {
					content: {
						required: "Pole jest wymagane"
					},
					"g-recaptcha-response": messages.recaptcha
				}
			});
			form.validate(options);
		},
		pickDeliveryTime: function(settings) {
			var form = $('#delivery-time-form');
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					"zipCode": rules.zipCode,
					"cityName": rules.city
				},
				messages: {
					"zipCode": messages.zipCode,
					"cityName": messages.city
				}
			});
			form.validate(options);
		},
		pickDeliveryCity: function(settings) {
			var form = $('#delivery-city-form');
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					"zipCode": rules.zipCode,
					"cityName": rules.city
				},
				messages: {
					"zipCode": messages.zipCode,
					"cityName": messages.city
				}
			});
			form.validate(options);
		},
		pickShopDeliveryCity: function(settings) {
			var form = $('#search-city-form');
			var options = setOptions({
				submitHandler: function(form) {
					settings.submit(form);
				},
				rules: {
					"zipCode": rules.zipCode,
					"shopCode": "required"
				},
				messages: {
					"zipCode": messages.zipCode
				}
			});
			form.validate(options);
		},
		userDataDelete: function () {
			var options = setOptions({
				rules: {
					"confirmDeleteAccount": {
						required: true
					}
				},
				messages: {
					"confirmDeleteAccount": {
						required: "Usunięcie konta wymaga potwierdzenia"
					}
				},
				errorPlacement: accountErrorPlacement
			});
			$("#remove-account-form").validate(options);
		},
		userDataDate: function () {
			var options = setOptions({
				rules: {
					"dateOfBirth": {
						dateISO: true,
						date1900: true,
						agreementDateOfBirth: $('#date-form #date').data('agreementDateOfBirth')
					}
				},
				messages: {
					"dateOfBirth": {
						dateISO: "Podaj poprawną datę urodzin"
					}
				},
				errorPlacement: accountErrorPlacement
			});
			$("#date-form").validate(options);
		},
		userDataEmail: function () {
			var options = setOptions({
				rules: {
					"emailNew": rules.email,
					"emailNewRepeat": rules.emailRepeat
				},
				messages: {
					"emailNew": messages.email,
					"emailNewRepeat": messages.emailRepeat
				},
				errorPlacement: accountErrorPlacement
			});
			$("#email-form").validate(options);
		},
		userDataPassword: function () {
			var options = setOptions({
				rules: {
					"passwordNew": rules.strongPassword,
					"passwordOld": rules.passwordOld,
					"passwordNewRepeat": rules.passwordNewRepeat
				},
				messages: {
					"passwordOld": messages.passwordOld,
					"passwordNewRepeat": messages.passwordNewRepeat
				},
				errorPlacement: accountErrorPlacement
			});
			$("#password-form").validate(options);
		},
		userDataAddress: function (onSubmitCallback) {
			var form = $("#address-row form");
			var options = setOptions({
				submitHandler: onSubmitCallback,
				rules: {
					"firstName": rules.firstname,
					"surname": rules.surname,
					"frontUserType": rules.userType,
					"phone": rules.optionalPhone,
					"nip": rules.nip,
					"vatUe": rules.vatUe,
					"numberId": rules.numberId,
					"companyCountryCode": {
						required() {
							return form.find('#tax-identifier-selector').val() === 'VAT_UE';
						}
					},
					"companyName": rules.companyName,
					"homeAddress.zipCode": {
						zipCode: () => ({ isForeignCountryCode: $('#country').val() !== 'PL'})
					},
					"homeAddress.city": {
						maxlength: 40,
						city: true
					},
					"homeAddress.street": {
						minlength: 2,
						maxlength: 60,
						street: true
					},
					"homeAddress.houseNumber": {
						maxlength: 10,
						houseNumber: true
					},
					"homeAddress.flatNumber": rules.flat
				},
				messages: {
					"firstName": messages.firstname,
					"surname": messages.surname,
					"frontUserType": messages.userType,
					"phone": messages.phone,
					"nip": messages.nip,
					"vatUe": messages.vatUe,
					"numberId": messages.numberId,
					"companyCountryCode": messages.countryCode,
					"companyName": messages.companyName,
					"homeAddress.zipCode": messages.zipCode,
					"homeAddress.city": messages.city,
					"homeAddress.street": messages.street,
					"homeAddress.houseNumber": messages.houseNumber,
					"homeAddress.flatNumber": messages.flat
				},
				errorPlacement: accountErrorPlacement
			});
			form.validate(options);
		},
		entityInvoice: function({ $form, send }) {
			var options = setOptions({
				submitHandler: function () {
					send($form);
				},
				rules: {
					"firstName": rules.firstname,
					"surname": rules.surname,
					"companyName": rules.companyName,
					"employeeName": rules.employeeName,
					"nip": rules.nip,
					"vatUe": rules.vatUe,
					"numberId": rules.numberId,
					"taxIdCountryCode": {
						required() {
							return $form.find('input[id^="tax-identifier-selector"]').val() === 'VAT_UE';
						}
					},
					"countryCode": rules.countryCode,
					"zipCode": {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $form.find('input[id^="country-code-"]').val() !== 'PL'})
					},
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat,
					"role": rules.role,
					"internalId": rules.internalId
				},
				messages: {
					"firstname": messages.firstname,
					"surname": messages.surname,
					"companyName": messages.companyName,
					"nip": messages.nip,
					"employeeName": messages.employeeName,
					"vatUe": messages.vatUe,
					"numberId": messages.numberId,
					"taxIdCountryCode": messages.countryCode,
					"countryCode": messages.countryCode,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat,
					"role": messages.role,
					"internalId": messages.internalId
				},
				errorPlacement: accountErrorPlacement
			});
			$form.validate(options);
		},
		invoice: function ({ $form, send }) {
			var options = setOptions({
				submitHandler: function () {
					send($form);
				},
				rules: {
					"firstName": rules.firstname,
					"surname": rules.surname,
					"companyName": rules.companyName,
					"nip": rules.nip,
					"vatUe": rules.vatUe,
					"numberId": rules.numberId,
					"companyCountryCode": {
						required() {
							return $form.find('input[id^="tax-identifier-selector"]').val() === 'VAT_UE';
						}
					},
					"countryCode": rules.countryCode,
					"zipCode": {
						required: true,
						zipCode: () => ({ isForeignCountryCode: $form.find('input[id^="country-code-"]').val() !== 'PL'})
					},
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat
				},
				messages: {
					"firstname": messages.firstname,
					"surname": messages.surname,
					"companyName": messages.companyName,
					"nip": messages.nip,
					"vatUe": messages.vatUe,
					"numberId": messages.numberId,
					"companyCountryCode": messages.countryCode,
					"countryCode": messages.countryCode,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat
				},
				errorPlacement: accountErrorPlacement
			});
			$form.validate(options);
		},
		overpaymentReturn: function (onSubmitCallback) {
			const $form = $("#overpayment-return-form");
			const options = setOptions({
				submitHandler: onSubmitCallback,
				rules: {
					"accountOwner": rules.firstname,
					"bankName": rules.bankName,
					"bankAccount": rules.bankAccountNumber,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber":  rules.flat,
					"zipCode": rules.zipCode,
					"city": rules.city,
				},
				messages: {
					"accountOwner": messages.firstname,
					"bankName": messages.bankName,
					"bankAccount": messages.bankAccountNumber,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat,
					"zipCode": messages.zipCode,
					"city": messages.city,
				}
			});
			$form.validate(options);
		},
		delivery: function ({ $form, send }) {
			var options = setOptions({
				submitHandler: function () {
					send($form);
				},
				rules: {

					"addLine1": rules.firstname,
					"addLine2": rules.surname,
					"zipCode": rules.zipCode,
					"city": rules.city,
					"street": rules.street,
					"houseNumber": rules.houseNumber,
					"flatNumber": rules.flat
				},
				messages: {
					"addLine1": messages.firstname,
					"addLine2": messages.surname,
					"zipCode": messages.zipCode,
					"city": messages.city,
					"street": messages.street,
					"houseNumber": messages.houseNumber,
					"flatNumber": messages.flat
				},
				errorPlacement: accountErrorPlacement
			});
			$form.validate(options);
		},
		receiver: function ({ $form, send }) {
			var options = setOptions({
				submitHandler: function () {
					send($form);
				},
				rules: {
					"firstName": rules.firstname,
					"lastName": rules.surname,
					"phone": rules.phone,
				},
				messages: {
					"firstName": messages.firstname,
					"lastName": messages.surname,
					"phone": messages.phone
				},
				errorPlacement: function (error, element) {
					var $validateTarget = element.closest('.validate-target');
					$validateTarget.addClass('validate-error').removeClass('validate-ok');
					error.insertAfter(element);
				}
			});
			$form.validate(options);
		},
	};
	var methods = {
		firstname: function(value, element) {
			// pierwsza litera jest dozwoloną literą
			// pozostałe 39 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		surname: function(value, element) {
			// pierwsza litera jest dozwoloną literą
			// pozostałe 39 znaki mogą być literą, spacją i myślnikiem
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ']{1}[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- ']{1,39}$/.test(value) && !/.[\s]{2,}/.test(value) && !/.[-]{2,}/.test(value);
		},
		pesel: function(value, element) {
			var status = true;
			var pesel = value.replace(/[\ \-]/gi, "");
			if (pesel.length != 11) {
				status = false;
			} else {
				var steps = new Array(1, 3, 7, 9, 1, 3, 7, 9, 1, 3);
				var sum_nb = 0;
				var sum_c = 0;
				for (var x = 0; x < 10; x++) {
					sum_nb += steps[x] * pesel.charAt(x);
				}
				var sum_m = 10 - sum_nb % 10;
				if (sum_m != 10) {
					sum_c = sum_m;
				}
				if (sum_c != pesel.charAt(10)) {
					status = false;
				}
			}
			return status;
		},
		phone: function(value, element) {
			var number = value + '';
			if (number.length === 0) {
				return false;
			}
			var numberValue = number.match(/\d/g);
			if (numberValue !== null  && numberValue.length === 9) {
				return true;
			}
			return false;
		},
		street: function(value, element) {
			var testReg1 = new RegExp("^[0-9a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\\- .']{2,60}$");	//dozwolone znaki
			var testReg2 = new RegExp("[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+");					//min jedna litera
			return testReg1.test(value) && testReg2.test(value);
		},
		zipCode: function(value, element, params) {
			const formatZipCode = zipCode => `${zipCode.substr(0, 2)}-${zipCode.substr(2, 3)}`;

			if (typeof params === "object" && params.isForeignCountryCode) {
				return /^[a-zA-Z0-9\- ]{0,8}$/.test(value);
			}

			let status = true;
			const zipCode = value.replace(/[\ \-]/gi, "");

			if (/\d{5}/.test(zipCode) && zipCode.length >= 5) {
				$(element).val(formatZipCode(zipCode));
			} else {
				status = false;
			}

			return status;
		},
		city: function(value, element) {
			return /^[a-zA-ZąćęłńóśżźĄĆĘŁŃÓŚŻŹ\- .]{2,40}$/.test(value);
		},
		houseNumber: function(value, element) {
			var max = 10;
			if (value.length > max) {
				return false;
			} else if (/[1-9]/.test(value) && !/;/.test(value) && /^[^\-].*/.test(value)) {  // min 1 cyfra, brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		flat: function(value, element) {
			var max = 10;
			if (value.length > max) {
				return false;
			} else if (!/;/.test(value) && /^[^\-].*/.test(value)) {  // brak średnika, nie zaczyna się od "-"
				return true;
			}
			return false;
		},
		percentageShare(value, element) {
			if (value && value.length && /^\d{1,3}([,.]\d{1,6})?$/.test(value)) { // np. 25,50 % (max 9 cyfr w tym max 6 miejsc po przecinku)
				return parseFloat(value.replace(',', '.')) <= 100;
			}
			return false;
		},
		date1900: function (value, element) {
			var data = value.split('-');
			var today = new Date();
			var y = data[0] / 1;
			var m = data[1] / 1;
			var d = data[2] / 1;
			var DOB = new Date(y, m - 1, d, 0, 0, 0);
			var max = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
			if (y > 1900 && y <= today.getFullYear() && m > 0 && d > 0 && DOB < max) {
				return true;
			}
			return false;
		},
		internalId(value, element) {
			if (value && value.length) {
				const parts = value.split('-');
				if (parts.length !== 2) {
					return false;
				}
				const [nip, id] = parts;
				if (nip.length !== 10) {
					return false;
				}
				return methods.nipValidator(nip) && /^\d{5}$/.test(id); // np. 5270005984-12345 - pierwsza część przed myślnikiem spełnia warunki dla NIP
			}
			return false;
		},
		vatUe: function (value, element) {
			var rules = ''+$(element).data('nip-rules');
			return value && value.length && rules && rules.length ? new RegExp(rules, "g").test(value) : false;
		},
		numberId(value, el) {
			return /^[^\s]{1,50}$/.test(value);
		},
		nipValidator(nip) {
			var verificator_nip = new Array(6, 5, 7, 2, 3, 4, 5, 6, 7);
			var n = 0;
			var ile;
			for (var i = 0; i < 9; i++) {
				ile = nip.charAt(i) / 1 * verificator_nip[i] / 1;
				n += ile;
			}
			// walidacja odrzuca nip z samymi zerami
			if (n === 0) {
				return false;
			}
			// czy wszystkie cyfry są takie same
			const allDigitsSame = nip.split('').every(digit => digit === nip[0]);
			if (allDigitsSame) {
				return false;
			}
			n %= 11;
			if (n != nip.charAt(9)) {
				return false;
			} else {
				return true;
			}
		},
		employeeName(value, element) {
			// Walidacja jak dla nazwy firmy
			return methods.companyName(value, element);
		},
		numberIdCountryCode(value, element) {
			return value === '';
		},
		companyName: function (value, element) {
			var result = value.split('').filter(function (y) {
				let char = y.charCodeAt();
				return char > 20 && char < 383;
			});
			return result.length === value.length;
		},
		nip: function(value, element) {
			var status = false;
			if (jQuery(element).val() === "") {
				status = true;
			} else {
				var nip = value.replace(/[\ _\-]/gi, "");
				if (/\d{3}-\d{2}-\d{2}-\d{3}/.test(value) || /\d{3}-\d{3}-\d{2}-\d{2}/.test(value) || /\d{10}/.test(value)) {
					status = true;
					if (nip.length != 10) {
						status = false;
					} else {
						status = methods.nipValidator(nip);
						if (!front.katalog && status === true && !/\d{3}-\d{3}-\d{2}-\d{2}/.test(value)) {
							jQuery(element).val(nip.substr(0, 3) + "-" + nip.substr(3, 2) + "-" + nip.substr(5, 2) + "-" + nip.substr(7, 3));
						}
					}
				} else {
					status = false;
				}
			}
			return status;
		},
		passwordStrong: function () {
			return passwordInvalid.check();
		},
		bankAccountNumber: function (value, element) {
			const digits = value.replace(/\s/g, '');
			if (/^\d{26}$/.test(digits)) {
				$(element).val(digits);
				return true;
			}
			return false;
		},
	};

	function task(name, params) {
		if (name && tasks[name]) {
			tasks[name](params);
		}
	}
	function resetForm($form){
		$('textarea, input', $form).val('').trigger('change').removeClass('error');
		$('.validate-target', $form).removeClass('validate-error');
		$('label.error', $form).remove();
	}
	var addedMethods = [
		['vatUe', 'Podaj poprawny numer VAT UE'],
		['percentageShare', 'Podaj poprawny Udział'],
		['companyName', 'Nazwa firmy zawiera niepoprawne znaki'],
		["employeeName", "Podaj poprawne imię i nazwisko pracownika"],
		['internalId', 'Podaj poprawne ID Wewnętrzne'],
		['numberId', 'Podaj poprawny Numer ID'],
		['phone', 'Podaj poprawny numer telefonu'],
		['zipCode', 'Podaj poprawny kod pocztowy'],
		['pesel', 'Podaj poprawny PESEL'],
		['houseNumber', 'Podaj poprawny numer domu'],
		['flat', 'Podaj poprawny numer mieszkania'],
		['date1900', 'Zakres daty urodzin jest niewłaściwy'],
		['street', 'Podaj poprawną ulicę'],
		["numberIdCountryCode", "Nie sprzedajemy usług cyklicznych na identyfikatory podatkowe powiązane z zagranicą."],
		['passwordStrong', false, true],
		['bankAccountNumber', 'Podaj poprawny numer konta bankowego'],
	];
	$(document).ready(function() {
		$(addedMethods).each(function(i, n) {
			var fn = methods[n[0]];
			$.validator.addMethod(n[0], function(value, element, param) {
				if (n[2]) {
					return fn(value, element, param);
				} else {
					return this.optional(element) || fn(value, element, param);
				}
			}, n[1]);
		});
	});
	return {
		task: task,
		resetForm: resetForm
	};
});

jQuery.validator.addMethod("childBenefit", function(value, element) {
	var $childBenefit = $('#childBenefit');
	var $dependantsNumber = $('#dependantsNumber').length ? $('#dependantsNumber') : $('#numberOfPeopleInTheHousehold');
	var v1= $dependantsNumber.val() || 0;
	var v2 = $childBenefit.val() || 0;
	var child = v1 > 0 ? $dependantsNumber.find('option[value='+v1+']').data('i')/1 : 0;
	var p500 =  v2 > 0 ? $childBenefit.find('option[value='+$childBenefit.val()+']').data('i')/1 : 0;
	if(child != ''){
		if(child * 500 >= p500){
			return true;
		}
	}
	return false;
}, "Wartość świadczenia 500+ jest niezgodna z liczbą dzieci na utrzymaniu.");
